module.exports = __webpack_public_path__ + "static/img/zhckzz_1.35354339.png";